import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/images/icon-cloud-computing-white.svg'


const _hoisted_1 = { class: "asChat_header" }
const _hoisted_2 = { class: "asChat_author" }
const _hoisted_3 = { class: "asChat_time" }
const _hoisted_4 = { class: "asChat_row" }
const _hoisted_5 = { class: "asChat_avatar" }
const _hoisted_6 = { class: "asChat_col" }
const _hoisted_7 = {
  key: 0,
  class: "asChat_newMessageLabel"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "asChat_newMessageLabel-icon" }, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "asChat_images"
}
const _hoisted_10 = ["src", "onClick"]
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_13 = { class: "asChat_item -image" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_18 = ["href"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 1,
  class: "asChat_feedback"
}
const _hoisted_21 = { class: "asChat_stars" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 2,
  class: "asChat_writing"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "asChat_circles" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "asChat_circle" }),
  /*#__PURE__*/_createElementVNode("div", { class: "asChat_circle" }),
  /*#__PURE__*/_createElementVNode("div", { class: "asChat_circle" })
], -1)
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_avatar = _resolveComponent("as-avatar")!
  const _component_as_modal = _resolveComponent("as-modal")!
  const _component_as_expert_rating = _resolveComponent("as-expert-rating")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["asChat_message", `-${_ctx.message.type}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.message.author), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.prettyDate(_ctx.message.createdAt)) + " " + _toDisplayString(_ctx.message.note), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.message.avatar)
          ? (_openBlock(), _createBlock(_component_as_avatar, {
              key: 0,
              src: _ctx.message.avatar,
              width: 42,
              height: 42
            }, null, 8, ["src"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.message.text)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["asChat_content", {
            '-feedback': _ctx.message.isShowFeedback,
            '-isNewMessage': _ctx.message.isNewMessage
          }])
            }, [
              (_ctx.message.isNewMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('New message')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.message.message && _ctx.message.message.files)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getImages(_ctx.message.message.files), (file, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "asChat_item -image",
                        key: `image${i}`
                      }, [
                        _createElementVNode("img", {
                          class: "-thumbnail",
                          src: file.urls.small,
                          onClick: ($event: any) => (_ctx.showImage(file))
                        }, null, 8, _hoisted_10),
                        _createElementVNode("a", {
                          href: file.urls.large,
                          class: "asChat_itemButton -download",
                          download: "",
                          target: "_blank"
                        }, [
                          _hoisted_12,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('downloadFile')), 1)
                        ], 8, _hoisted_11)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVideos(_ctx.message.message.files), (file, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `video${i}`,
                          class: "video_wrapper"
                        }, [
                          _createElementVNode("div", {
                            class: "video_content",
                            onClick: ($event: any) => (_ctx.showVideo(file))
                          }, [
                            _createElementVNode("video", {
                              src: file.url,
                              class: "-thumbnail",
                              preload: "true",
                              playsinline: ""
                            }, null, 8, _hoisted_15)
                          ], 8, _hoisted_14),
                          _createElementVNode("a", {
                            href: file.url,
                            class: "asChat_itemButton -download",
                            download: "",
                            target: "_blank"
                          }, [
                            _hoisted_17,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('downloadFile')), 1)
                          ], 8, _hoisted_16)
                        ]))
                      }), 128))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDocs(_ctx.message.message.files), (file, i) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: `doc${i}`,
                        href: file.url,
                        target: "_blank",
                        class: "asChat_item -doc"
                      }, null, 8, _hoisted_18))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "asChat_text",
                ref: "message",
                innerHTML: _ctx.msg(_ctx.message.text)
              }, null, 8, _hoisted_19)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.message.isShowFeedback || _ctx.message.isRequestFeedback)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_ctx.message.isRequestFeedback)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('evaluateExpertMessage')), 1)
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                  return _createElementVNode("div", {
                    key: `star${i}`,
                    class: _normalizeClass(["asChat_star", {
                '-disabled': !_ctx.isCanChangeRate,
                '-active': _ctx.rate >= i,
                '-isRated': Boolean(_ctx.rate)
              }]),
                    onClick: ($event: any) => (_ctx.setRate(i))
                  }, null, 10, _hoisted_22)
                }), 64))
              ]),
              (_ctx.rate)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "asChat_changeRating",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChangeRating()))
                  }, _toDisplayString(_ctx.$t('ratingPopup.changeRating')), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.message.writing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('writingMessage')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_as_modal, {
      btnClose: true,
      "type-modal": _ctx.modalValue && _ctx.modalValue.type,
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModal) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.modalValue && _ctx.modalValue.type === 'image')
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.modalValue.value
            }, null, 8, _hoisted_25))
          : _createCommentVNode("", true),
        (_ctx.modalValue && _ctx.modalValue.type === 'video')
          ? (_openBlock(), _createElementBlock("video", {
              key: 1,
              src: _ctx.modalValue.value,
              controls: "",
              preload: "true"
            }, null, 8, _hoisted_26))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["type-modal", "modelValue"]),
    _createVNode(_component_as_modal, {
      "btn-close": false,
      "backdrop-close": false,
      modelValue: _ctx.isShowRatingModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isShowRatingModal) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_as_expert_rating, {
          onClose: _ctx.closeRatingModal,
          onRated: _ctx.onRated,
          "chat-message": _ctx.message,
          "chat-id": _ctx.chatId,
          rating: _ctx.rate
        }, null, 8, ["onClose", "onRated", "chat-message", "chat-id", "rating"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}